<template>
  <div>
    <el-card class="searchItemFlex">
      <el-radio-group v-model="query.state" @change="getAnnexList">
        <el-radio-button :label="0">启用</el-radio-button>
        <el-radio-button :label="1">禁用</el-radio-button>
      </el-radio-group>
      <el-button type="primary" icon="el-icon-plus" class="right" @click="openAddAnnexDialog">添加附件项</el-button>
    </el-card>
    <el-card>
      <el-table :data="annexList" ref="PhotoProTable" height="610" border v-loading="loading" @sort-change="sortChange"
        element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.8)">
        <el-table-column prop="id" label="ID" width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="name" label="附件名称" width="160" show-overflow-tooltip sortable="'custom'"></el-table-column>
        <el-table-column prop="symbol" label="附件标识" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="type" label="附件类型" width="80">
          <template v-slot="{ row }">
            <span>{{ row.type === 0 ? '图片' : 'pdf' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="saveMust" label="是否必传" width="80">
          <template v-slot="{ row }">
            <span>{{ row.saveMust ? '必传' : '非必传' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80">
          <template v-slot="{ row }">
            <el-tag :type="row.state === 0 ? 'success': 'danger'">{{ row.state === 0? '启用' : '禁用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180" show-overflow-tooltip sortable="'custom'">
          <template v-slot="{ row }">
            <span>{{ row.createTime | dateformatAll('YYYY-MM-DD HH:mm:ss')}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" min-width="180">
          <template v-slot="{ row }">
            <el-button type="text" @click="edit(row)">编辑</el-button>
            <el-button type="text" @click="changeState(row)">{{ row.state === 0 ? '禁用' : '启用' }}</el-button>
            <el-button v-show="row.state === 0" type="text" @click="packageAnnex(row)">打包全部</el-button>
            <el-button v-show="row.state === 0" type="text" @click="downloadPackage(row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <AnnexOperator ref="AnnexOperator" :flush="getAnnexList" :visible="annexVisible" @changeVisible="val => annexVisible = val" />
  </div>
</template>
<script>
import { page, state, packageAnnex, checkPackage } from '@/api/employeeAnnex'
import AnnexOperator from './components/AnnexOperator'
export default {
  name: 'Annex',
  components: { AnnexOperator },
  data() {
    return {
      query: {
        state: 0,
        orderColumn: 'createTime',
        isAsc: true,
      },
      annexList: [],
      loading: false,
      annexVisible: false,
    }
  },
  mounted() {
    this.getAnnexList()
  },
  methods: {
    async getAnnexList() {
      this.loading = true
      const { data: res } = await page(this.query).catch(err => err)
      if (res) {
        this.annexList = res
      }
      this.loading = false
    },
    sortChange({ prop, order }) {
      console.log(prop, order)
      this.query.orderColumn = prop
      this.query.isAsc = order === 'ascending'
      this.getAnnexList() 
    },
    openAddAnnexDialog() {
      this.annexVisible = true
      this.$nextTick(() => {
        this.$refs.AnnexOperator.init(null)
      })
    },
    edit(row) {
      this.annexVisible = true
      this.$nextTick(() => {
        this.$refs.AnnexOperator.init(row)
      })
    },
    async changeState(row) {
      const newState = row.state ^ 1
      const text = newState === 0 ? '启用' : '禁用'
      const conf = await this.$confirm(`将要${text}该附件项，请确定是否继续？`, '提示', {
        type: 'warning'
      }).catch(err => err)
      if (conf !== 'confirm') {
        return this.$message.info('已取消操作')
      }
      const { data: res } = await state(row.id, newState).catch(err => err)
      if (res) {
        this.$message.success(`操作成功！`)
        this.getAnnexList()
      }
    },
    async packageAnnex(row) {
      const conf = await this.$confirm(`将要打包该附件项下的所有人的附件，这需要消耗一定时间，请稍侯数分钟再进行下载，已打包的会重新打包覆盖，请确定是否继续？`, '提示', {
        type: 'warning'
      }).catch(err => err)
      if (conf !== 'confirm') {
        return this.$message.info('已取消操作')
      }
      this.loading = true
      const { data: res } = await packageAnnex(row.id).catch(err => err)
      if (res) {
        this.$message.success(`操作成功！打包程序已执行，请稍候数分钟进行下载。`)
      }
      this.loading = false
    },
    async downloadPackage(row) {
      this.loading = true
      const { data: res } = await checkPackage(row.id).catch(err => err)
      if (res) {
        // 下载
        // 拼接后端静态文件的获取链接
        const url = `${window.g.BASE_URL}annexPackage/${row.name}.zip`
        const a = document.createElement('a')
        a.href = url
        // 设置a标签在新的页面打开
        a.target = '_blank'
        a.download = `${row.name}-资料包.zip`
        a.click()
      } else {
        this.$message.warning('该附件项还未打包，或打包尚未完成，请重试或稍后再试！')
      }
      this.loading = false
    }
  },
}
</script>
<style scoped lang="less">
</style>
